// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { StatementSummary } from "@werner/App/Services/AccountInquiryService";

import { Draft } from "immer";

export interface AccountInquiryState {
    isLoading: boolean;
    data?: StatementSummary;
    failedMessage?: string;
}

const initialState: AccountInquiryState = {
    isLoading: false,
    data: undefined,
    failedMessage: "",
};

const reducer = {
    "xAccountInquiry/BeginLoadAccountInquiry": (draft: Draft<AccountInquiryState>, action: {}) => {
        draft.isLoading = true;
        draft.failedMessage = "";
    },
    "xAccountInquiry/FailedToLoadAccountInquiry": (
        draft: Draft<AccountInquiryState>,
        action: { failedMessage: string },
    ) => {
        draft.isLoading = false;
        draft.failedMessage = action.failedMessage;
    },
    "xAccountInquiry/CompleteLoadAccountInquiry": (
        draft: Draft<AccountInquiryState>,
        action: { data: StatementSummary },
    ) => {
        draft.isLoading = false;
        draft.data = action.data;
        draft.failedMessage = "";
    },
};

const xAccountInquiry = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).xAccountInquiry = xAccountInquiry;

export type xAccountInquiry = {
    xAccountInquiry: AccountInquiryState;
} & ApplicationState;
